import { render, staticRenderFns } from "./LoginBanner.vue?vue&type=template&id=4e47b81b"
import script from "./LoginBanner.vue?vue&type=script&lang=js"
export * from "./LoginBanner.vue?vue&type=script&lang=js"
import style0 from "./LoginBanner.vue?vue&type=style&index=0&id=4e47b81b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports